<div class="dialog" id="simpleModal" data-type="simple">
    <div class="slider-content" style="width: 60%;top:17%;position: fixed;">
        <button data-close="true">X</button>
        <ng-image-slider 
            [images]="images"
            [infinite]="false"
            [autoSlide]="1"
            [imageSize]="{width: '100%', height: '100%'}"
            slideImage="1"
        ></ng-image-slider>
    </div>    
</div>